import { Injectable } from '@angular/core';
import { Converter } from '../../converter.interface';
import { isNullOrUndefined } from 'util';
import { TechnicalSubprocessObject } from 'src/app/models/orders/order-details-process/process-details/technical-subprocess-object.model';

@Injectable({
    providedIn: 'root'
})
export class OrderDetailsProcessBpmActivitiesConverter implements Converter<Array<TechnicalSubprocessObject>> {

    subprocessList: Array<TechnicalSubprocessObject> = new Array<TechnicalSubprocessObject>();
    subprocess;
    constructor() { }

    convert(input: any): Array<TechnicalSubprocessObject> {
        if (isNullOrUndefined(input)) {
            return new Array<TechnicalSubprocessObject>();
        }
        this.subprocessList = new Array<TechnicalSubprocessObject>();

        for (this.subprocess of input.bpmActivities) {
            var subProcStartDate: Date = null;
            if (this.subprocess.stateDate != null) {
                subProcStartDate = new Date(this.subprocess.stateDate);
            }

            this.subprocess = new TechnicalSubprocessObject(this.subprocess.name, this.subprocess.type,
                this.subprocess.state, subProcStartDate, this.subprocess.archived);

            this.subprocessList.push(this.subprocess);
        }
        return this.subprocessList;
    }
}